export default __webpack_public_path__ + "static/media/340.d7562873.png";